module.exports = __webpack_public_path__ + "static/reporting-f74230266d7d2f467dc305c14a3ff112.png";